import get from 'lodash/get';
import resolveFamilyMemberOption from '../../../utils/converters/resolveFamilyMemberOption';

const getRole = (member, formatMessage) => {
  const careRole = get(member, 'careRole');
  const additionalRole = careRole
    ? formatMessage({ id: `circles.roles.${careRole}` })
    : null;
  const role = resolveFamilyMemberOption(member, formatMessage, additionalRole);

  return role || '';
};

export function getUser(member, formatMessage) {
  const {
    login,
    displayableName: memberName,
    avatar: memberAvatar,
    id: memberId,
    user,
    invitationId,
  } = member;
  const { displayableName: userName, avatar: userAvatar, id: userId } =
    user || {};
  const name = memberName || userName;
  const displayableName = name || login;
  const avatar = memberAvatar || userAvatar;
  const id = memberId || userId || invitationId;
  const role = getRole(member, formatMessage);

  return {
    role,
    user: {
      displayableName,
      avatar,
      id,
    },
  };
}



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/utils/getUser.js